import { gql } from 'graphql-request'

export namespace TicketHomeAreas {
  export const QUERY_KEY = 'TicketHomeAreas'

  export function getTicketHomeAreas() {
    return gql`
      query TicketHomeAreas {
        ticketHomeAreas {
          id
          description
        }
      }
    `
  }
}
